<template>
  <div class="home-cover relative">
    <div id="carousel" class="carousel">
      <div v-for="(cover, index) in covers" :key="cover.id" class="carousel-cell">
        <img class="cover-image lg:hidden" :src="cover.image_mobile" :alt="cover.alt">
        <img class="cover-image hidden lg:block" :src="cover.image" :alt="cover.alt">
        <div class="floating-box">
          <h1 class="text-[28px] lg:text-[40px] font-extrabold text-white">{{ $t('home.title') }}</h1>
          <h1 class="text-[84px] lg:text-[100px] font-extrabold text-white" v-html="cover.title"></h1>
          <div class="text-base lg:text-[20px] font-medium text-white mt-3 w-[350px]"
            :class="isBannerId2 ? 'lg:w-[600px]' : 'lg:w-[450px]'" v-html="cover.description"></div>
          <v-btn :href="cover.path" rounded elevation="0" color="secondary" height="50"
            class="avm-btn avm-btn--medium mt-4">
            {{ $t('home.reserve-now') }}
          </v-btn>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      covers: [],
    };
  },
  created() {
    this.fetchCovers();
  },
  computed: {
    isBannerId2() {
      return this.covers.some(cover => cover.id === 2);
    },
  },
  methods: {
    async fetchCovers() {
      try {
        const response = await fetch('/api/covers');
        this.covers = await response.json();
        this.$nextTick(() => {
          this.initCarousel();
        });
      } catch (error) {
        console.error('Error fetching covers:', error);
      }
    },
    initCarousel() {
      var elem = document.getElementById('carousel');
      var flkty = new Flickity(elem, {
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true,
        autoPlay: 4000,
        pauseAutoPlayOnHover: false
      });
    }
  }
}
</script>

<style lang="scss">
@import '../../../sass/_variables.scss';

.v-btn__content {
  letter-spacing: normal !important;
}

.home-cover {
  .carousel {
    background: #EEE;
    width: 100%;
    overflow: hidden;
  }

  .floating-box {
    position: absolute;
    left: 1rem;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: $breakpoint-landing-phone) {
      top: 3rem;
    }

    h1,
    span {
      font-family: 'Baloo2';
    }

    h6 {
      font-family: 'Avenir-Heavy';
    }

    @media (min-width: $breakpoint-landing-phone) {
      padding: 60px 100px;
    }
  }

  .cover-image {
    height: 500px;
    width: 100%;
    object-fit: cover;
  }

  .carousel-cell {
    width: 100%;
    position: relative;
  }

  .flickity-page-dots {
    bottom: 20px;
  }

  /* white circles */
  .flickity-page-dots .dot {
    width: 12px;
    height: 12px;
    opacity: 1;
    background: transparent;
    border: 2px solid white;
  }

  /* fill-in selected dot */
  .flickity-page-dots .dot.is-selected {
    background: white;
  }
}
</style>
